import {resetPassword} from "../../api/user";
import React from 'react';
import moment from 'moment';

class TestComp extends React.Component {
    constructor(props) {
        super(props);
        console.log(props);
    }
    render() {
        console.log('render TestComp');
        return <div>
            <h1>Test {this.props.text}</h1>
            <button onClick={() => {for (let i = 0; i < 3; ++i) this.forceUpdate()}}>refresh</button>
        </div>
    }
}

const Test2Comp = ({text}) => {
    console.log('render Test2Comp');
    return <div>
        <h1>Test {text}</h1>
    </div>
}
class TestPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {text: ""};
        this.n = 0;
    }
    render() {
        console.log('render');
        const str = moment().format("YYYY-MM-DD hh:mm");
        const m = moment(str, "YYYY-MM-DD hh:mm");
        console.log(m);
        return (
            <div>
                {str}
            <button onClick={() => {
                this.setState({...this.state, text: (new Date()).toString()});
                this.n++;
            }}>test</button>
                {this.n % 2 === 0 && <TestComp text={this.state.text}/>}
            </div>
            );
    }
}


export default TestPage;
